/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * If the business is a financial institution, this field describes its primary regulator.
 */
export const PrimaryRegulator = {
  Occ: "OCC",
  Fdic: "FDIC",
  Ncua: "NCUA",
  Frb: "FRB",
  StateCuRegulator: "state-cu-regulator",
} as const;
/**
 * If the business is a financial institution, this field describes its primary regulator.
 */
export type PrimaryRegulator = ClosedEnum<typeof PrimaryRegulator>;

/** @internal */
export const PrimaryRegulator$inboundSchema: z.ZodNativeEnum<
  typeof PrimaryRegulator
> = z.nativeEnum(PrimaryRegulator);
/** @internal */
export const PrimaryRegulator$outboundSchema: z.ZodNativeEnum<
  typeof PrimaryRegulator
> = PrimaryRegulator$inboundSchema;
